import React, { useState, useEffect } from "react";
import { FaFileExcel, FaTrash } from "react-icons/fa";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { motion } from "framer-motion";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import { SuwasthiLoader } from "../components/loader";
import Pagination from "../components/pagination";
import AssignRoleModal from "../components/assignRoleModal";
import Breadcrumb from "../components/breadcrumb";
import { Link } from "react-router-dom";

const AttendanceList = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    fetchEmployees();
  }, [currentPage, itemsPerPage, search, startDate, endDate]);
  
 
  const fetchEmployees = () => {
    setLoading(true);
  
    // Build query params dynamically
    const params = new URLSearchParams();
    params.append("page", currentPage);
    params.append("limit", itemsPerPage);
  
    if (search) {
      params.append("search", search);
    }
  
    if (startDate) {
      params.append("startDate", startDate.toISOString().split("T")[0]); // yyyy-mm-dd format
    }
  
    if (endDate) {
      params.append("endDate", endDate.toISOString().split("T")[0]);
    }
  
    // If you want to add employeeStatus filter, add a state and append here
    // if (employeeStatus) {
    //   params.append("employeeStatus", employeeStatus);
    // }
  
    fetch(`${apiurl}/api/employee/filter?${params.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        setEmployees(data.employees);
        setTotalItems(data.pagination?.totalItems || 0);
        setLoading(false);
        setSelectedEmployees([]);
        setSelectAll(false);
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
        setLoading(false);
      });
  };

  
  const handleLimitChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleCheckboxChange = (employeeId) => {
    setSelectedEmployees((prev) =>
      prev.includes(employeeId)
        ? prev.filter((id) => id !== employeeId)
        : [...prev, employeeId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedEmployees([]);
    } else {
      setSelectedEmployees(employees.map((emp) => emp._id));
    }
    setSelectAll(!selectAll);
  };

  const filteredEmployees = employees.filter((emp) => {
    const lowerSearch = search.toLowerCase();

    return (
      emp?.personalDetails?.firstName?.toLowerCase().includes(lowerSearch) ||
      emp?.personalDetails?.lastName?.toLowerCase().includes(lowerSearch) ||
      emp?.personalDetails?.email?.toLowerCase().includes(lowerSearch) ||
      emp?.personalDetails?.aadharNumber?.toLowerCase().includes(lowerSearch) ||
      emp?.employeeId?.toLowerCase().includes(lowerSearch) ||
      emp?.employeeCode?.toLowerCase().includes(lowerSearch)
    );
  });



  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: index * 0.05, duration: 0.3 },
    }),
  };

  console.log("selectedEmployees", selectedEmployees);

  const handleDeleteSelected = async () => {
    if (
      !window.confirm("Are you sure you want to delete the selected employees?")
    )
      return;

    try {
      const response = await fetch(`${apiurl}/api/employee/bulk-delete`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ employeeObjIds: selectedEmployees }),
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Employees deleted successfully.");
        fetchEmployees();
      } else {
        alert(result.error || "Failed to delete employees.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("An error occurred while deleting employees.");
    }
  };

  return (
    <Layout>
      {/* <Breadcrumb /> */}
      <Container overflow="overflow-scroll">
        <div className="p-6 bg-gray-100">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
            <input
              type="text"
              placeholder="Search by name, email, employee ID, code, or Aadhar"
              className="p-2 border rounded w-full md:w-1/3"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />


            <select
              className="p-2 border rounded"
              value={itemsPerPage}
              onChange={handleLimitChange}
            >
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
              <option value="2000">2000</option>
              <option value="5000">5000</option>
            </select>
            {/* {selectedEmployees.length > 0 && (
              <button
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                onClick={() => setIsModalOpen(true)}
              >
                Assign Role
              </button>
            )} */}
          </div>

          {loading ? (
            <SuwasthiLoader />
          ) : (
            <div className="bg-white shadow-md rounded-lg p-4 overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-3">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="p-3 text-left">HRMS ID</th>
                    <th className="p-3 text-left">Employee ID</th>
                    <th className="p-3 text-left">Name</th>
                    <th className="p-3 text-left">Email</th>
                    <th className="p-3 text-left">Status</th>
                    <th className="p-3 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.map((employee, index) => (
                    <motion.tr
                      key={employee._id}
                      className="border-b"
                      variants={listVariants}
                      initial="hidden"
                      animate="visible"
                      custom={index}
                    >
                      <td className="p-3">
                        <input
                          type="checkbox"
                          checked={selectedEmployees.includes(employee._id)}
                          onChange={() => handleCheckboxChange(employee._id)}
                        />
                      </td>
                      <td className="p-3">{employee.id}</td>
                      <td className="p-3">{employee.employeeId ? `SUW${employee.employeeId}` : ""}</td>
                      {/* <td className="p-3">{employee.employeeId}</td> */}
                      <td className="p-3">
                        {employee?.personalDetails?.firstName}{" "}
                        {employee?.personalDetails?.lastName}
                      </td>
                      <td className="p-3">
                        {employee?.personalDetails?.email}
                      </td>
                      <td className="p-3">{employee?.employeeStatus}</td>
                      <td className="p-3">
                        <Link to={`/payroll/attendance/${employee?.employeeId}`}>View</Link>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {isModalOpen && (
            <AssignRoleModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              selectedApplications={selectedEmployees}
            />
          )}

          <Pagination
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={setCurrentPage}
          />
        </div>
      </Container>
    </Layout>
  );
};

export default AttendanceList;